// src/screens/GmailOAuthCallback.js
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import request from '../utils/request';

export default function GmailOAuthCallback() {
  const navigate = useNavigate();
  const { search } = useLocation(); // "?code=…&state=…"

  useEffect(() => {
    (async () => {
      try {
        await request.get(`/hosts/oauth/callback${search}`, { withCredentials: true });
        // on success, manually drive the user home
        navigate('/settings');
      } catch (err) {
        console.error('OAuth callback failed', err);
        navigate('/settings?error=1');
      }
    })();
  }, [search, navigate]);

  return (
    <div className="p-6 flex items-center justify-center text-[#6B7280]">
      Finalizing Gmail connection…
    </div>
  );
}
